import { DeleteIcon } from './DeleteIcon';

/**
 * author: Google
 * id 71CD492D-A1E8-4A7A-961A-51DA30952BAD
 * name delete
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/delete.svg
 * tags
 */
export const GarbageCanIcon = DeleteIcon;
export default GarbageCanIcon